.share-dialog-title {
  margin: 0 !important;
  font-size: 18px !important;
  font-weight: 600 !important;
  color: #ffffff !important;
  text-align: center !important;
  font-family: "Inter-SemiBold", "Inter", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif !important;
}

/* Both buttons with identical styling */
.share-dialog-copy-btn,
.share-dialog-share-btn,
.share-dialog-feed-btn {
  padding: 14px 20px !important;
  border: 1px solid #404040 !important;
  border-radius: 12px !important;
  background: #2a2a2a !important;
  color: #ffffff !important;
  font-size: 16px !important;
  font-weight: 500 !important;
  cursor: pointer !important;
  transition: all 0.2s ease !important;
  font-family: "Inter-Medium", "Inter", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif !important;
  margin: 0 !important;
  width: 100% !important;
  box-shadow: none !important;
  margin-bottom: 12px !important;
}

/* Hover effects for both buttons */
.share-dialog-copy-btn:hover,
.share-dialog-share-btn:hover,
.share-dialog-feed-btn:hover {
  background: #3a3a3a !important;
  border-color: #555555 !important;
}

/* Focus states */
.share-dialog-copy-btn:focus,
.share-dialog-share-btn:focus,
.share-dialog-feed-btn:focus {
  outline: none !important;
  box-shadow: none !important;
}

html body.swal2-height-auto {
  height: inherit !important;
}

.share-dialog-popup {
  border-radius: 16px !important;
  padding: 12px 24px !important;
  width: fit-content !important;
  background-color: #212121 !important;
  border: 0.5px solid #404040 !important;
}
